var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 24H84","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M76 24V80C76 84 72 88 68 88H28C24 88 20 84 20 80V24","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M32 24V16C32 12 36 8 40 8H56C60 8 64 12 64 16V24","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Trash.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Trash;

Trash.default = Trash;
